import { create } from "zustand";

export type Auth = {
  resizeToMobile: boolean;
  setResizeToMobile: (resizeToMobile: boolean) => void;
  materialFilter: null | string;
  setMaterialFilter: (materialFilter: null | string) => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
};

const useUserStore = create<Auth>((set) => ({
  resizeToMobile: false,
  setResizeToMobile: (resizeToMobile: boolean) =>
    set({ resizeToMobile: resizeToMobile }),
  materialFilter: null,
  setMaterialFilter: (materialFilter: null | string) =>
    set({ materialFilter: materialFilter }),
  currentPage: 0,
  setCurrentPage: (page) => set({ currentPage: page }),
}));

export default useUserStore;
